import { render } from "./TextView.vue?vue&type=template&id=61f7144e&scoped=true"
import script from "./TextView.vue?vue&type=script&lang=js"
export * from "./TextView.vue?vue&type=script&lang=js"

import "./TextView.vue?vue&type=style&index=0&id=61f7144e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f7144e"]])

export default __exports__